import { Injectable } from '@angular/core';
import { WidgetManager } from '@mhe/reader/transform/widget-manager';

@Injectable({ providedIn: 'root' })
export class WidgetsRegistryService {
  private readonly managers = new Map<string, WidgetManager>();

  register(uuid: string, manager: WidgetManager): void {
    this.managers.set(uuid, manager);
  }

  get(uuid: string): WidgetManager | undefined {
    return this.managers.get(uuid);
  }

  remove(uuid: string): void {
    this.managers.delete(uuid);
  }

  clear(): void {
    this.managers.clear();
  }
}
